import styled, { CSSObject } from '@emotion/styled'

import { colors } from 'component-library/__styling/settings'
import { WebLink } from 'common/navigation/web-link'
import { themedValue } from 'component-library/__styling/themed-value'
import { Theme } from 'component-library/__styling/themes'

export function getCommonLinkStyles(theme: Theme): CSSObject {
    return {
        textDecoration: 'underline',
        color: themedValue(theme, {
            thewest: section => section.primaryColor,
            perthnow: colors.perthnow.blueKyanite,
            sevennews: colors.sevennews.resolutionBlue,
        }),

        '&:hover': {
            backgroundColor: themedValue(theme, {
                fallback: undefined,
                perthnow: colors.perthnow.blueKyanite,
            }),
            color: themedValue(theme, {
                thewest: colors.thewest.greyKoala,
                perthnow: colors.white,
                sevennews: colors.sevennews.blueRibbon,
            }),
            textDecoration: themedValue(theme, { thewest: 'underline', fallback: 'none' }),
        },

        '&:focus': {
            backgroundColor: themedValue(theme, {
                fallback: undefined,
                perthnow: colors.perthnow.blueKyanite,
            }),
            color: themedValue(theme, {
                thewest: colors.black,
                perthnow: colors.white,
                sevennews: colors.sevennews.blueRibbon,
            }),
            border: undefined,
        },
    }
}

export const StyledTextLink = styled(WebLink)(({ theme }) => getCommonLinkStyles(theme))
